import { useTranslation } from 'react-i18next';
import { Select } from "./mode-input.styled";

const modes = [
  { value: 'regular', name: 'Штатный' },
  { value: 'emergency', name: 'Блокированный' },
  { value: 'test', name: 'Сервисный' },
  { value: 'free', name: 'Свободный' },
];

export const ModeInput = (props) => {
  const { t } = useTranslation();
  const { onChange, ...rest } = props;

  /**
   * get items els
   * @returns
   */
  const getItemsEl = () => {
    return modes.map((el, idx) => {
      return (
        <option key={idx} value={el.value}>
          {t('clarifications.' + el.name)}
        </option>
      );
    });
  };

  /**
   * on change
   * @param {*} event
   */
  const change = (event) => {
    onChange(props.name, event.target.value);
  };

  const itemsEl = getItemsEl();

  return (
    <Select {...rest} onChange={change}>
      {itemsEl}
    </Select>
  );
};
